export enum SpecificLaneCompositionType {
  allLanesCompleteCarriageway,
  lane1,
  lane2,
  lane3,
  lane4,
  lane5,
  lane6,
  lane7,
  lane8,
  lane9
}



// WEBPACK FOOTER //
// ./src/app/models/enums/specificlanecompositiontype.ts